import React, { useEffect, useRef } from 'react';
import SwaggerUI from 'swagger-ui';

import 'swagger-ui/dist/swagger-ui.css';

declare const __OPENAPI_SPEC_VERSION__: string;

const OPENAPI_SPEC_URL = `/openapi.yaml?v=${__OPENAPI_SPEC_VERSION__}`;

export const ApiDocs = () => {
  const swaggerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ui = SwaggerUI({
      domNode: swaggerRef.current as HTMLElement,
      url: OPENAPI_SPEC_URL,
      docExpansion: 'list',
      defaultModelsExpandDepth: 0,
    });

    return () => {
      if (ui && typeof ui.destroy === 'function') {
        ui.destroy();
      }
    };
  }, []);

  return (
    <div className="container-fluid py-4">
      <div ref={swaggerRef} />
    </div>
  );
};

export default ApiDocs;
